style= require('./logs.styl')

.tabs
  ul
    each item in tabs
      li(class={'active':this.tab === item},(click)=setTab(item))= this.tabsTranslations[item]

.search
  .item
    .icon
      ft-icon(name='ui--activity')
    .info
      h5 Activity
      .filter-dropdown
        span
          label From date
          sporty-form-field([(value)]=this.start)
            input(type='date')
        span
          label To date
          sporty-form-field([(value)]=this.end)
            input(type='date')
      span= 'sorting by '
        if users
          ft-form-field(type='text')
            select.select-players(
              (change)=this.setPlayer(e))
              option.opt(value='all')= 'all'
              each user in users
                option.opt(value=user)= user.username || user.email
ft-loading(loaded=!this.$isLoading, manual)
  if logs && logs.length
    .logs
      .loading(loading=$isLoading)
        .box
          ft-icon(name="ui--period")
          span= 'loading'
      each log in logs
        .item(class=`info-${log._id}`)
          .popup(class={'active':this.userInfo === log._id})
            .close((click)=this.toggleUserInfo(log))
              ft-icon(name='ui--cross')
            .icon
              span=this.abriviature( log.user.username)
            .popup-info
              .popup-name= log.user.username
              .popup-email=  log.user.email
              .popup-role=  log.user.role

          .icon
            span((click)=this.toggleUserInfo(log))=this.abriviature( log.user.username)
          .info
            .user
              b= log.user.username || log.user.email
              span.user-action= this.translations[log.action] || log.action
            .time
              = `${moment(log.time).format('lll')}`
              span= ` - on ${log.subjectName}`
              ft-icon(name='ui--lock')
            .obj= log.subject?.name
            .action
                if ["newPlayer","editPlayer"].includes(log.action)
                  each action in log.subject
                    span
                      if action.firstName
                        = `firstName ${action.firstName}`
                      if action.lastName
                        = ` lastName ${action.lastName}`
                      if action.position
                        = ` position ${action.position}`
                      if action.team
                        = ` team ${this.findTeam(action.team)}`
                      if action.player
                        = ` player ${this.findPlayer(action.player)}`
                      if action.source
                        = ` source ${action.source}`

                else if ["newLeague","editLeague"].includes(log.action)
                  -var subject = log.subject || {}
                  = `${log.action} ${subject.name} ${subject.sport}`
                else if ["editTeam"].includes(log.action)
                  each action in log.subject
                    span
                      if action.firstName
                        = `priority ${action.source.priority}`
                      if action.team
                        = ` team ${this.findTeam(action.team)}`
                else if ["newTeam"].includes(log.action)
                  each action in log.subject
                    span
                      if typeof action === "object"
                        if action.priority
                          = `priority ${action.priority}`
                        if action.source
                          = ` source ${action.source}`
                        if action.tag
                          = ` tag ${action.tag}`
                        if action.team
                          = ` team ${this.findTeam(action.team)}`
                      else
                        = action
                else if ["mapTeam"].includes(log.action)
                  each action in log.subject
                    span
                      if action.source
                        = ` source ${action.source.priority} team ${this.findTeam(action.source.team)}`
                      else
                        = action
                else if ["unmapTeam","unmapMatch"].includes(log.action)
                  each subject in log.subject
                    div= `team ${this.findTeam(subject)}`
                else if ["price"].includes(log.action)
                  - let prices = log.subject.matchPrices
                  .price-header
                    if log.subject.player
                      .player= findPlayer(log.subject.player)
                    .season= findSeason(log.subject.season)
                  if prices
                    each entry in Object.entries(prices)
                      .match-price
                        .match= findMatch(entry[0])
                        each change in matchPriceChanges(entry[1])
                          div(class=change.attr)= `${change.label}: ${change.value}`
                  if log.subject.disabled
                    .disabled Price Disabled (N/A)
                  else if log.subject.disabled === false && !prices
                    .enabled Price Enabled
                  if log.subject.status
                    .status=`status ${log.subject.status}`
                  if log.subject.seasonPrice
                    .price= `Season Price ${log.subject.seasonPrice}`
                  if log.subject.oldSeasonPrice
                    .price= `Previously ${log.subject.oldSeasonPrice}`

                else if ["lineup"].includes(log.action)
                  .match= `Match: ${this.findMatch(log.object.match)}`
                  -var array = Array.isArray(log.subject.lineups)
                  if array
                    each lineup in log.subject.lineups
                      span
                        if lineup.status
                          = `created with ${lineup.status}`
                        if lineup.player
                          = ` - player ${this.findPlayer(lineup.player)}`
                  else  
                    -var lineup = log.subject.lineups
                    span
                      if lineup.status
                        = `created with ${lineup.status}`
                      if lineup.player
                        = ` - player ${this.findPlayer(lineup.player)}`
                else if ["lineupUpdated"].includes(log.action)
                  .match= `Match: ${this.findMatch(log.object.match)}`
                  each lineup in log.subject.lineups
                    span
                      if lineup.status
                        = `updated with ${lineup.status}`
                      if lineup.player
                        = ` - player ${this.findPlayer(lineup.player)}`
                else if ["newMatch"].includes(log.action)
                  if Array.isArray(log.subject)
                    each match in log.subject
                      span.match.plural= `match ${this.findMatch(match?.match?._id)}`
                      span.match-teams
                        if match?.teamOverrides
                          = `${match?.teamOverrides[0]} - ${match?.teamOverrides[1]}`
                      if match.source
                        span.round= `do - ${match.source} round - ${match.round}`
                      if match.startTime
                        span= `${moment(match.startTime).format('lll')}`
                      if match.endTime
                        span= `${moment(match.endTime).format('lll')}`
                  else
                    span.match= `match ${this.findMatch(log.subject.match)}`
                    span.match-teams
                      if log.subject.teamOverrides
                        = `${log.subject.teamOverrides[0]} - ${log.subject.teamOverrides[1]}`
                    span.round= `do - ${log.subject.source} round - ${log.subject.round}`
                    if action.endTime
                      span= `${moment(action.endTime).format('lll')}`
                else if log.action.includes('Match')
                  if Array.isArray(log.subject)
                    each match in log.subject
                      span.match= `match ${this.findMatch(match.match)}`
                      span.match= `Action ${log.action}`
                  else 
                    span.match= `match ${this.findMatch(log.object._id)}`
                    span.match= `Action ${log.action}`
                else if ["editEvent", "newEvent", "removeEvent"].includes(log.action)
                  if log.subject
                    span=`${log.action} ${log.subject.name} for`
                    span= this.findPlayer(log.subject.player)
                    span= this.findTeam(log.subject.team)
                    span= this.findMatch(log.subject.match)
                    span= log.minute
                else
                  = `something else`
            .difference
              -var keys = Object.keys(log.updatedValues)
              if keys.length
                span= `${log.action} fields:`
                each key in keys
                  div.row
                    span=key
                    span=` from ${this.getProperValue(key, log.updatedValues[key].oldValue)} `
                    span=` to ${this.getProperValue(key,log.updatedValues[key].newValue)} `
      ft-pagination(
        current=this.page || 0,
        size=this.size,
        total=this.total,
        display=this.display,
        border,
        (currentChanged)=this.changePage(e.current)
      )
  else
    p.no-stats= 'No stats for the current time, default - last 24 hours'
